import { db } from "../firebase/config";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";

// Validate invite token
export async function validateInvite(token) {
  const ref = doc(db, "invites", token);
  const snap = await getDoc(ref);

  if (!snap.exists()) return { valid: false };

  const data = snap.data();
  if (data.used) return { valid: false };

  return { valid: true, data: { ...data, token } };
}

// Mark invite as used with full user info
export async function markInviteUsed(token, user) {
  const ref = doc(db, "invites", token);
  await updateDoc(ref, {
    used: true,
    usedBy: {
      uid: user.uid,
      email: user.email,
      phone: user.phone,
      joinedAt: Date.now(),
    },
  });
}

// Admin creates invite
export async function createInvite(adminUid) {
  const ADMIN_UID = "I41qVJFkMhUcs2j3Gl8ytQx6qx33"; // your admin UID
  if (adminUid !== ADMIN_UID) throw new Error("Not authorized");

  const token = crypto.randomUUID();
  const ref = doc(db, "invites", token);

  await setDoc(ref, {
    createdAt: Date.now(),
    used: false,
    token,
  });

  return token;
}
